import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createPendingPaymentSlice = (set, get) => ({
    pendingPayment: {
        loading: false,
        data: [],
        comments: []
    },
    getPendingPayment: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ pendingPayment: { ...state.pendingPayment, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "v1/business/business-pending-payment-request",
                headers: { token },
            });
            set(state => ({ pendingPayment: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ pendingPayment: { ...state.pendingPayment, loading: false } }));
        }
    }
});